import { useEffect, useMemo } from 'react';
import { execGlobalJS } from '@icp/app-core';
import { message as messageApi, restApi } from '@icp/settings';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function useGlobalJS(script, { modal }) {
  const navigate = useNavigate();
  const routerApi = useMemo(() => {
    return { navigate };
  }, [navigate]);

  const { t, i18n } = useTranslation();
  const i18nApi = useMemo(() => {
    return { language: i18n.language, t };
  }, [i18n.language, t]);

  useEffect(() => {
    if (!script) return;
    execGlobalJS(script, {
      i18nApi,
      restApi,
      messageApi,
      routerApi,
      modalApi: modal,
    });
    // 不相应 dependency 变化，只执行一次
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
